module.exports = {"prodUri":"http://test.admin.evclub.com","onLineProdUri":"http://app.admin.api.chargerlink.com","devUri":"http://devel.admin.evclub.com","mobile":false,"testing":false}


//////////////////
// WEBPACK FOOTER
// ./config/app/appBackend.json
// module id = 269
// module chunks = 2